import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Divider } from 'antd';

import { selectTranslations } from 'app/pages/App/slice/selectors';
import { Layout } from 'app/pages/NewAccount/layouts';
import { Text, Title } from '../../components/Typo';
import { ReactComponent as SuccessIcon } from 'app/assets/img/success_icon.svg';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import useWindowSize from 'app/hooks/useWindowSize';

const TicketRefundSuccess = () => {
  const translations = useSelector(selectTranslations);
  const { state } = useLocation<any>();
  const orderDetailData = state?.orderData;
  const originPage = state?.originPage;
  const orderId = orderDetailData?.id;
  const idHash = orderDetailData?.idHash;
  const history = useHistory();
  const { device } = useWindowSize();
  const isMobile = device === 'mobile';

  const onGoToDetail = () => {
    history.push(`/ticket-refund/detail/${idHash}`, {
      originPage,
    });
  };

  useLayoutEffect(() => {
    const onHaveNoData = () => {
      if (!orderDetailData) history.push('/page-not-found');
    };

    onHaveNoData();
  }, [history, orderDetailData]);

  return (
    <Layout
      title={null}
      menuActive={
        typeof originPage === 'string'
          ? ACCOUNT_MNG_MENU.CHECK_TICKET
          : ACCOUNT_MNG_MENU.PURCHASE_HISTORY
      }
    >
      <div
        className="d-flex align-items-center justify-content-center flex-column"
        style={{
          padding: '50px 0',
        }}
      >
        <div className="d-flex align-items-center justify-content-center flex-column">
          <SuccessIcon />
          <Title
            style={{
              fontSize: 20,
              marginTop: 24,
              textAlign: 'center',
              lineHeight: '28px',
            }}
          >
            {translations?.['b2b.txt.ticketCancellationSuccessful'] ?? ''}
          </Title>
          <div style={{ marginTop: 32 }}>
            <Title style={{ textTransform: 'initial' }}>
              {translations?.['b2b.txt.ticketCancellationCode'] ?? ''}{' '}
              <span style={{ color: '#E92127' }}>{orderId}</span>
            </Title>
          </div>
          <div style={{ marginTop: 20 }}>
            <Text style={{ textAlign: 'center' }}>
              {translations?.['b2b.msg.ticketCancellationSuccess'] ?? ''}
            </Text>
            <Text style={{ textAlign: 'center' }}>
              {translations?.['b2b.msg.ticketCancellationRefer'] ?? ''}{' '}
              <span
                style={{ color: '#FF7A00', cursor: 'pointer' }}
                onClick={onGoToDetail}
              >
                {translations?.['b2b.txt.here'] ?? ''}
              </span>
            </Text>
          </div>
          <Divider
            dashed
            style={{
              borderWidth: '2px 0 0',
              borderColor: '#D9D9D9',
              width: isMobile ? 'calc(100% + 18px)' : 'calc(100% + 160px)',
              marginTop: 15,
              marginBottom: 28,
            }}
          />
          <Text style={{ textAlign: 'center' }}>
            {translations?.['b2b.txt.ticketRefundContact'] ?? ''}
          </Text>
          <Title
            style={{ marginTop: 20, fontWeight: 500, textTransform: 'initial' }}
          >
            Hotline{' '}
            <span style={{ color: '#E92127', fontWeight: 700 }}>
              {translations?.['b2b.txt.hotline'] ?? ''}
            </span>
          </Title>
        </div>
      </div>
    </Layout>
  );
};

export default TicketRefundSuccess;
